<template>
  <TsSection class="md:mt-6 mt-4">
    <TsTypography append-class="mb-4 " weight="normal" as="h2" align="center"
      >No products found in that category</TsTypography
    >

    <TsImage
      width="160"
      class="text-center mx-auto"
      src="/images/searchResultNotFound.svg"
      loading="lazy"
    />
  </TsSection>
</template>
<script setup lang="ts">

const searchResultStore = useSearchResultStore();
useHead({
  title: "Toolstation | Search",
  meta: [{ name: "description", content: "search result" }],
});

const products = ref({
  breakpoints: {
    0: {
      itemsToShow: 2.1,
      snapAlign: "start",
    },
    640: {
      itemsToShow: 4,
      snapAlign: "start",
    },
    1024: {
      itemsToShow: 5,
      snapAlign: "center",
    },
  },
  data: [],
});

onMounted(async () => {
  try {
    const { default: defaultProducts } = await import('~/json/products-dummy.json');
    products.value.data = defaultProducts;
    console.log('Products loaded:', products.value.data);
  } catch (error) {
    console.error("Failed to load default products:", error);
  }
});

const productsRecommendationsChips = [
  "Often Bought Together",
  "You may also like",
  "Best seller",
  "New arrival",
  "Related products",
];

</script>
